import { NgModule } from '@angular/core';
import { AsidePanelComponent } from './aside-panel.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [AsidePanelComponent],
    exports: [AsidePanelComponent],
    imports: [CommonModule],
})
export class AsidePanelModule {}
